import { InputBase, TableRow, Switch } from "@material-ui/core";
import { createStyles, fade, withStyles } from "@material-ui/core/styles";

export const Input = withStyles((theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      textAlign: "center",
      borderRadius: theme.shape.borderRadius,
      position: "relative",
      // backgroundColor: theme.palette.common.white,
      backgroundColor: "transparent",
      border: "1px solid #ced4da",
      // paddingLeft: "6px",
      // paddingRight: "6px",
      paddingTop: "4px",
      paddingBottom: "4px",
      fontSize: 14,
      //   width: "auto",
      // padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.

      "&:focus": {
        boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.1rem`,
        borderColor: theme.palette.primary.main,
        // zIndex: 1,
      },
      "&[type=number]": {
        "-moz-appearance": "textfield",
        "-webkit-appearance": "textfield",
      },
      "&::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "&::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
    error: {
      //backgroundColor: `${theme.palette.error.light}`,
      '& input':{
        borderColor: theme.palette.error.main,
        '&:focus':{
          borderColor: theme.palette.error.main,
          boxShadow:'none'
        }
      } 
    },
    disabled: {
      backgroundColor: theme.palette.grey[200],
    },
  })
)(InputBase);

export const InputLabel = withStyles((theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      textAlign: "center",
      borderRadius: theme.shape.borderRadius,
      position: "relative",
      // backgroundColor: theme.palette.common.white,
      backgroundColor: "transparent",
      border: "1px solid #ced4da",
      // paddingLeft: "6px",
      // paddingRight: "6px",
      paddingTop: "4px",
      paddingBottom: "4px",
      fontSize: 14,
      //   width: "auto",
      // padding: "10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
    },
  })
)(InputBase);

export const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#f3f2f3",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: "#fff",
    },
  },
}))(TableRow);

export const StyledSwitch = withStyles((theme) => ({
  switchBase: {
    // color: theme.palette.grey[600],
    "&$checked": {
      color: theme.palette.common.white,
      "& $thumb": {
        backgroundColor: theme.palette.common.white,
      },
    },
    "&$checked + $track": {
      backgroundColor: theme.palette.common.white,
    },
  },
  checked: {},
  track: {
    // border: `1px solid ${theme.palette.grey[400]}`,
  },
  thumb: {
    // boxShadow: "none",
    backgroundColor: theme.palette.grey[400],
  },
}))(Switch);
